var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show
    ? _c("input", {
        attrs: { type: "checkbox" },
        domProps: { checked: _setup.isChecked },
        on: { change: _setup.setValue },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }